import { render, staticRenderFns } from "./settings-lists-transactionitems.vue?vue&type=template&id=b8a55684&"
import script from "./settings-lists-transactionitems.ts?vue&type=script&lang=ts&"
export * from "./settings-lists-transactionitems.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports